/**
 *
 * @param {Event} e
 * @param {String} selector
 * @returns {HTMLElement|null}
 */
export function getElementFromEvent(e, selector) {
	if (!e.target) {
		return null;
	}

	const el = e.target?.closest(selector);

	if (!el) {
		return null;
	}

	return el;
}

export function getKeyboardFocusableElements(element = document) {
	return [
		...element.querySelectorAll(
			'a[href], button, input, textarea, select, details,[tabindex]:not([tabindex="-1"])'
		),
	].filter((el) => !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden'));
}

export async function callApi(route) {
	try {
		const response = await fetch(`${WPURLS.laravel_url}/api/${route}`, {
			credentials: 'include',
		});
		const json = await response.json();

		return json;
	} catch (error) {
		console.error('Error fetching API:', error);
		return {};
	}
}

export function scrollToAnchor(trigger, container) {
	if (trigger.href) {
		const url = trigger.href.split('#');

		if (typeof url[1] !== 'undefined') {
			const el = container.querySelector(`#${url[1]}`);

			window.scrollTo({
				top: el.getBoundingClientRect().top + window.scrollY - 60,
			});
		}
	}
}
